import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FancyGraphicDrawerComponent } from './fancy-graphic-drawer/fancy-graphic-drawer.component';

@NgModule({
  declarations: [FancyGraphicDrawerComponent],
  exports: [FancyGraphicDrawerComponent],
  imports: [CommonModule],
})
export class FancyGraphicsModule {}
